<script setup lang="ts" generic="TOption, TValue">
import { mdiCheck } from "@mdi/js";
import { ComboboxItem, ComboboxItemIndicator, ComboboxLabel } from "reka-ui";
import Icon from "../icon/Icon.vue";
import type { ListOption, OptionItem } from "../listbox/listbox";

const props = defineProps<{ option: ListOption<TOption, TValue> }>();
const emit = defineEmits<{
	select: [option: OptionItem<TOption, TValue>];
}>();

defineSlots<{
	label?(slotProps: { label: string }): any;
	option?(slotsProps: { option: TOption }): any;
}>();
</script>

<template>
	<ComboboxItem
		v-if="props.option.type === 'item'"
		class="command-item w-full"
		:value="props.option.value as any"
		:disabled="props.option.disabled"
		@select="emit('select', props.option)"
	>
		<slot name="option" :option="props.option.option">
			{{ props.option.label }}
		</slot>
		<span class="flex-center absolute right-2">
			<ComboboxItemIndicator>
				<Icon size="sm" :d="mdiCheck" />
			</ComboboxItemIndicator>
		</span>
	</ComboboxItem>

	<ComboboxLabel
		v-else-if="props.option.type === 'label'"
		class="text-muted-content w-full px-2 py-1.5 text-sm font-medium"
	>
		<slot name="label" :label="props.option.label">
			{{ props.option.label }}
		</slot>
	</ComboboxLabel>
</template>
